import { useMutation } from '@tanstack/react-query';
import apiClient from './api-client';
export async function subscribeToNewsletter(data) {
    const response = await apiClient.post('/newsletter/subscribe', data);
    return response.data;
}
export function useNewsletterSubscription() {
    return useMutation({
        mutationFn: subscribeToNewsletter,
    });
}
